import React from "react";
import * as Components from "../components/all";
// facilities
import facilitiesBg from "../assets/facilities-bg.png";
// range
import rangeBg from "../assets/range-bg.png";
// fantastic
import fantasticBg from "../assets/fantastic-bg.png";
// teaching
import teachingBg from "../assets/teaching-bg.png";
import teachingBg1 from "../assets/teaching-bg1.png";
// may also like
import support from "../assets/support.png";
import campuses from "../assets/campuses.png";
import union from "../assets/union.png";
import { Slide } from "pure-react-carousel";

export default function FacilitiesScreen() {
	return (
		<div className="FacilitiesScreen">
			{/* Navbar */}
			<Components.Navbar white={true} />

			{/* Facilities */}
			<div
				className="FACILITIES relative 
                min-h-[100vh] w-full 
                flex flex-col-reverse md:flex-row 
                items-center justify-center md:justify-between 
                py-12 pt-40 md:pb-24
                "
			>
				{/* left */}
				<div
					className="relative 
                    w-full md:w-[45%] lg:w-[40%]   
                    px-12 md:pl-24 md:pr-0
                    pt-5
                    max-sm:mt-20 sm:my-20 md:my-0 
                    flex flex-col items-start 
                    text-left
                    "
				>
					<Components.Heading
						className="relative 
                            w-full 
                            flex
                            "
					>
						KidverCity <br />
						Facilities
					</Components.Heading>

					{/* vectors */}
					<svg
						width="292"
						height="430"
						viewBox="0 0 292 630"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
						className="absolute 
                        top-0 left-[-50px]
                        max-md:hidden
                        "
					>
						<path
							d="M291.723 1H92.0514L-291.813 629.273"
							stroke="#FFE303"
							strokeWidth="2"
						/>
					</svg>
					<svg
						width="90"
						height="240"
						viewBox="0 0 90 240"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
						className="absolute 
                        top-0 left-0
                        md:hidden
                        "
					>
						<path
							d="M89.3066 1H13.5811L-132 239.274"
							stroke="#FFE303"
							strokeWidth="2"
						/>
					</svg>
				</div>

				{/* right */}
				<div
					className="relative 
                    w-full md:w-[55%] lg:w-[50%]
                    max-w-[850px] min-w-[350px] 
                    z-0
                    px-12 md:pr-24 md:pl-0
                    "
				>
					<img
						loading="lazy"
						src={facilitiesBg}
						alt="dates_img"
						className="w-full object-contain"
					/>
				</div>
			</div>

			{/* Range */}
			<div
				className="RANGE relative 
				min-h-[100vh] w-full 
			  bg-[#F5F5F5] 
				flex flex-col 
				items-start justify-center 
				p-12 lg:p-24
				"
			>
				<img
					loading="lazy"
					src={rangeBg}
					alt="range_bg_img"
					className="w-full object-contain max-w-[1400px]"
				/>

				<Components.SubHeading
					className="text-start 
                    max-w-[830px]
                    mt-12
                    "
				>
					We have a wide range of fantastic facilities available for our
					students. Take a look at what we can offer.
				</Components.SubHeading>

				<Components.BigParagraph
					className="text-left text-[#00000099] 
						mt-8 
                        max-w-[800px]
						"
				>
					You can also view our facilities through our virtual tours, when you
					can follow a member of staff as they show you around on a video tour,
					explore our facilities in 3D by clicking on the pins on a map, or view
					photo galleries of what happens on our courses and campuses.
				</Components.BigParagraph>

				<div
					className="w-full relative 
                    "
				>
					<Components.Button text="Explore our Facilities" className="my-8" />

					<svg
						width="149"
						viewBox="0 0 149 129"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
						className="absolute 
                        right-[-80px] md:right-0 
                        top-[-10px] md:top-0
                        h-[50px] md:h-[90px]
                        "
					>
						<path
							d="M24.1932 81.5743C21.3205 109.105 64.5574 129.4 104.217 88.5212C136.096 55.6629 97.9469 37.2354 80.9956 54.5958C72.3121 63.4876 77.0996 75.4648 87.1006 74.85C123.084 72.6487 140.266 10.1224 97.8433 7.18662C97.8433 7.18662 98.6795 6.4883 99.0352 6.49727C138.591 7.43445 127.925 64.3333 93.2086 74.2393C65.1213 82.2515 71.581 46.4018 99.1044 47.0919C112.514 47.4279 132.919 63.9677 100.755 92.5796C60.4375 128.444 20.156 109.345 23.3205 81.9769C23.3535 81.7184 24.1932 81.5743 24.1932 81.5743Z"
							fill="#FFE303"
						/>
						<path
							d="M34.0693 92.3294C29.4987 92.1351 23.3101 83.8085 22.855 79.1382C23.2694 78.9478 23.6851 78.7532 24.0995 78.5627C23.5181 84.0369 22.7014 89.7121 20.778 94.8922C20.7112 95.0752 19.9201 95.325 19.9399 95.2197C20.9314 89.837 22.2749 84.6014 22.8522 79.1396C22.8827 78.8415 24.0851 78.4505 24.0968 78.5641C24.5377 83.0878 29.7338 90.1127 34.7421 91.9366C34.8363 91.9686 34.2047 92.3343 34.0693 92.3294Z"
							fill="#FFE303"
						/>
					</svg>
				</div>
			</div>

			{/* Our Facilities */}
			<div
				className="OUR-FACILITIES relative bg-white 
				min-h-[500px] w-full 
				flex flex-col 
				px-12 py-24 md:px-24
				"
			>
				{/* heading & btns*/}
				<div className="relative flex justify-between">
					<Components.SubHeading className="text-left">
						Our Facilities
					</Components.SubHeading>

					<div className="hidden md:flex items-center">
						<Components.ArrowLeft className="h-[28px]" />

						<Components.ArrowRight className="h-[32px] ml-2" />
					</div>
				</div>

				{/* cards */}
				<div className="w-full flex justify-center my-16 overflow-hidden">
					<Components.Carousel slidesTotal={4}>
						<Slide index={1} className="h-full flex">
							<div
								className="bg-[#F5F5F5] 
								max-md:min-w-[250px] h-[130px]
								flex flex-col 
								items-center justify-center
								cursor-pointer shadow-sm
								hover:opacity-80
								mx-auto
								aspect-video
								"
							>
								<div
									className="h-[50px] 
                            aspect-square
                            bg-[#C33B4C1A]
                            flex items-center justify-center
                            "
								>
									<svg
										width="36"
										height="28"
										viewBox="0 0 36 28"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M0.188965 14.9774C0.545124 14.4339 1.06466 14.2528 1.68811 14.2938C1.83509 14.3033 1.98685 14.2753 2.13109 14.2992C2.43598 14.3505 2.55766 14.2336 2.63901 13.9335C2.76958 13.4536 3.12915 13.1802 3.62545 13.1118C4.08894 13.0476 4.55516 13.0462 5.01933 13.1057C5.69541 13.1918 6.12335 13.6649 6.1377 14.3491C6.14864 14.8947 6.15001 15.4409 6.13702 15.9864C6.13087 16.2373 6.21769 16.335 6.47199 16.322C6.78987 16.3056 7.10843 16.32 7.42699 16.3166C7.50423 16.3159 7.61361 16.3241 7.65053 16.2803C7.72435 16.1915 7.61634 16.1163 7.57054 16.0459C6.90745 15.0362 6.32843 13.9821 5.87178 12.8616C5.2121 11.2401 4.83749 9.56459 4.9578 7.80635C5.20458 4.19008 7.89662 1.01131 11.4548 0.234051C14.6677 -0.467328 17.4322 0.411105 19.6881 2.82287C20.0935 3.25627 20.017 3.17356 20.3321 2.83039C22.2243 0.769315 24.578 -0.173378 27.3575 0.0323876C29.2655 0.173894 30.9355 0.93338 32.3472 2.23565C32.6541 2.51866 32.6924 2.8174 32.4668 3.07033C32.2385 3.32668 31.9131 3.31917 31.5959 3.03C30.4707 2.00186 29.154 1.3538 27.6474 1.17059C25.0237 0.851348 22.8081 1.68877 21.0526 3.67669C20.3519 4.47036 19.6895 4.47856 18.9806 3.67327C17.6428 2.15293 15.9748 1.29501 13.9438 1.12752C10.0493 0.80623 6.53283 3.67737 6.09122 7.60127C5.90596 9.24876 6.23273 10.8375 6.85481 12.3681C7.39759 13.7025 8.11948 14.9357 8.94186 16.1149C9.06627 16.2933 9.2153 16.3214 9.40739 16.3207C10.6693 16.3166 11.9319 16.3186 13.1939 16.3186C13.2848 16.3186 13.3757 16.3173 13.4666 16.3193C13.8659 16.3261 14.1195 16.5401 14.1127 16.8621C14.1058 17.1738 13.8611 17.3823 13.4817 17.3878C13.0838 17.3932 12.686 17.3891 12.2874 17.3891C10.3658 17.3891 8.44419 17.3953 6.52189 17.383C6.21837 17.3809 6.12198 17.478 6.13634 17.7747C6.15685 18.2061 6.16095 18.6395 6.13565 19.0701C6.11651 19.3976 6.24913 19.4694 6.5506 19.4687C9.64392 19.4598 12.7366 19.4632 15.8299 19.4632C16.2503 19.4632 16.6721 19.4502 17.0918 19.4673C17.3632 19.4782 17.4528 19.3737 17.4445 19.1098C17.4295 18.6552 17.4268 18.1999 17.4452 17.7453C17.4575 17.4514 17.3352 17.3721 17.0631 17.3844C16.6885 17.4014 16.3125 17.3932 15.9379 17.3864C15.5701 17.3796 15.322 17.1485 15.3322 16.8368C15.3418 16.5346 15.5783 16.3255 15.9338 16.32C16.3316 16.3138 16.7302 16.3077 17.1274 16.3214C17.3687 16.3296 17.4473 16.2311 17.4432 16.0001C17.4336 15.4887 17.4363 14.9767 17.4418 14.4647C17.45 13.6526 17.8882 13.1624 18.6914 13.0879C19.0989 13.0503 19.5084 13.0544 19.9172 13.1043C20.4784 13.1727 20.8448 13.4837 20.9781 14.019C21.0403 14.2692 21.147 14.3068 21.3698 14.3013C21.7437 14.2924 22.1204 14.2623 22.4923 14.3368C23.031 14.4442 23.4001 14.8256 23.4815 15.3711C23.5033 15.5167 23.5198 15.6651 23.5198 15.8121C23.5225 17.5744 23.5259 19.3374 23.5198 21.0998C23.5157 22.1457 23.0317 22.618 21.9878 22.6228C21.8853 22.6235 21.7813 22.6351 21.6809 22.6208C21.2782 22.564 21.0123 22.6468 20.8899 23.1109C20.786 23.5074 20.4319 23.7234 20.0252 23.7973C19.5521 23.8834 19.0715 23.8772 18.5978 23.8205C17.8923 23.7357 17.4589 23.2435 17.4432 22.5285C17.4309 21.983 17.435 21.4368 17.4411 20.8913C17.4432 20.6814 17.3735 20.5775 17.1472 20.5782C15.7711 20.583 14.3957 20.5809 13.0196 20.583C12.9888 20.583 12.958 20.6007 12.8938 20.6206C13.4331 21.1825 13.9944 21.6897 14.5638 22.186C16.1341 23.5532 17.7686 24.8405 19.4837 26.0224C19.8768 26.2938 20.127 26.3143 20.4839 26.0641C24.1528 23.4985 27.5551 20.637 30.3442 17.1054C31.7989 15.2631 33.0144 13.2834 33.6378 10.992C34.2004 8.92268 34.1423 6.90263 33.1121 4.96802C32.9036 4.57632 32.9747 4.27963 33.283 4.11557C33.5872 3.95355 33.8723 4.0766 34.0794 4.46215C35.2539 6.64696 35.3277 8.93294 34.6974 11.2798C34.1867 13.1815 33.2707 14.8892 32.1551 16.4964C30.174 19.3497 27.7191 21.756 25.0627 23.9695C23.7775 25.0401 22.4444 26.0477 21.0683 26.9979C20.5344 27.3664 19.965 27.4641 19.3566 27.2112C19.211 27.151 19.0729 27.0656 18.943 26.976C16.3152 25.1658 13.8481 23.1588 11.5963 20.8954C11.3687 20.6664 11.141 20.57 10.819 20.5734C9.40944 20.5884 7.99916 20.5795 6.58888 20.5802C6.14317 20.5802 6.14249 20.5823 6.14112 21.041C6.14044 21.5414 6.14659 22.0418 6.13839 22.5422C6.12677 23.2456 5.7125 23.7214 5.01112 23.8171C4.55994 23.8786 4.10398 23.8731 3.65143 23.8137C3.12574 23.7446 2.76684 23.4548 2.62397 22.9462C2.55082 22.685 2.41957 22.5955 2.1639 22.6208C2.00599 22.6365 1.84534 22.6153 1.68675 22.6249C1.06398 22.6625 0.543756 22.482 0.188965 21.9365C0.188965 19.617 0.188965 17.2969 0.188965 14.9774ZM5.02411 18.459C5.02411 17.3228 5.0289 16.1867 5.02274 15.0505C5.01727 14.0388 5.14374 14.1926 4.15798 14.1817C3.68561 14.1762 3.67809 14.1899 3.67399 14.6506C3.66989 15.162 3.68356 15.674 3.65211 16.1833C3.63092 16.521 3.39029 16.711 3.08882 16.7021C2.79487 16.6932 2.58774 16.4772 2.56313 16.1409C2.55219 15.9939 2.55424 15.8456 2.55834 15.6979C2.56381 15.5003 2.47905 15.4026 2.27533 15.4067C2.01419 15.4115 1.75237 15.4135 1.49123 15.4053C1.25676 15.3985 1.16721 15.5085 1.16721 15.7355C1.16994 17.5532 1.16994 19.3709 1.16721 21.1886C1.16652 21.4217 1.2718 21.5168 1.50012 21.5086C1.7387 21.5004 1.97796 21.4976 2.21586 21.5092C2.46264 21.5215 2.56655 21.4245 2.56039 21.1722C2.54946 20.7067 2.55766 20.2405 2.55766 19.7749C2.55834 19.3887 2.55014 19.0018 2.56245 18.6162C2.57407 18.2539 2.78257 18.0331 3.09156 18.0263C3.40943 18.0194 3.61725 18.217 3.66168 18.5793C3.67536 18.6914 3.67262 18.8063 3.67262 18.9197C3.6733 19.8857 3.66715 20.8509 3.67467 21.8169C3.68288 22.8881 3.5359 22.7083 4.59617 22.7397C4.9243 22.7493 5.03231 22.6365 5.0289 22.3104C5.01591 21.0266 5.02411 19.7428 5.02411 18.459ZM19.9124 18.4563C19.9124 17.3194 19.9151 16.1826 19.9117 15.0457C19.9083 14.0374 20.0081 14.1919 19.0346 14.1817C18.5616 14.1762 18.5595 14.1823 18.5595 14.6554C18.5588 17.0426 18.554 19.4304 18.5616 21.8175C18.565 22.8881 18.405 22.709 19.4796 22.7397C19.8057 22.7493 19.9206 22.6365 19.9178 22.3104C19.9042 21.0259 19.9117 19.7407 19.9124 18.4563ZM22.4109 18.4569C22.4109 17.5594 22.4048 16.6618 22.415 15.7642C22.4178 15.5003 22.3241 15.3889 22.0568 15.404C21.8073 15.4176 21.5571 15.4108 21.3069 15.4067C21.1053 15.4033 21.0212 15.4976 21.0212 15.6965C21.0232 17.5375 21.0232 19.3784 21.0212 21.2187C21.0212 21.419 21.1066 21.5113 21.3076 21.5072C21.5462 21.5024 21.7861 21.4928 22.0233 21.5106C22.3234 21.5332 22.4205 21.4101 22.4157 21.1155C22.4021 20.2295 22.4109 19.3429 22.4109 18.4569Z"
											fill="#C33B4C"
										/>
										<path
											d="M17.2207 8.31862C16.9486 9.20594 16.6745 10.0926 16.4038 10.9806C16.1522 11.8064 15.9034 12.6335 15.6525 13.4593C15.5199 13.8955 15.3216 14.1047 15.0386 14.0848C14.6626 14.0582 14.5457 13.7806 14.4528 13.4696C14.018 12.0224 13.5771 10.5773 13.1368 9.13211C12.9871 8.63991 12.9858 8.63991 12.4587 8.63991C11.1858 8.63991 9.91227 8.64128 8.63939 8.63923C8.09387 8.63855 7.82111 8.45056 7.81838 8.08278C7.81565 7.71158 8.08635 7.5229 8.62914 7.5229C10.1297 7.52222 11.6302 7.52222 13.1307 7.5229C13.7022 7.52359 13.8273 7.62476 13.9961 8.18327C14.3318 9.29207 14.6722 10.3988 15.0236 11.5493C15.1412 11.4632 15.1439 11.3484 15.1712 11.2588C15.6436 9.71659 16.1119 8.17301 16.5822 6.62943C16.6287 6.47698 16.6765 6.32591 16.7278 6.17483C16.8126 5.926 16.9753 5.75988 17.248 5.75783C17.5345 5.75578 17.7143 5.92326 17.797 6.18714C17.9973 6.82699 18.2099 7.46343 18.3774 8.11217C18.4642 8.44645 18.6125 8.56062 18.9625 8.55446C20.2128 8.53259 21.4632 8.54558 22.7135 8.54694C22.827 8.54694 22.9432 8.54147 23.0532 8.56198C23.3301 8.61325 23.5092 8.78415 23.527 9.06648C23.5447 9.35018 23.3875 9.54159 23.1154 9.61884C22.9979 9.65233 22.8693 9.66122 22.7456 9.66122C21.2902 9.66396 19.8355 9.66464 18.3801 9.66259C17.8182 9.6619 17.6828 9.56073 17.5174 9.03777C17.4422 8.80056 17.3704 8.56267 17.2966 8.32546C17.2713 8.32272 17.246 8.32067 17.2207 8.31862Z"
											fill="#C33B4C"
										/>
									</svg>
								</div>

								<Components.Paragraph className="font-bold mt-2">
									Sports and Fitness
								</Components.Paragraph>
							</div>
						</Slide>

						<Slide index={2} className="h-full flex">
							<div
								className="bg-[#C33B4C] 
									max-md:min-w-[250px] h-[130px]
									flex flex-col 
									items-center justify-center
									cursor-pointer shadow-sm
									hover:opacity-80
									mx-auto
									aspect-video
									"
							>
								<div
									className="h-[50px] 
                            aspect-square
                            bg-white
                            flex items-center justify-center
                            "
								>
									<svg
										width="33"
										height="32"
										viewBox="0 0 33 32"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M5.95337 31.9721C5.37895 31.8295 4.84215 31.6195 4.42289 31.1728C3.43078 30.1164 3.42765 28.6008 4.43543 27.5648C6.42435 25.5203 8.41876 23.4812 10.4085 21.4374C13.507 18.2566 16.6017 15.0726 19.7026 11.8941C20.364 11.2162 20.6313 10.4278 20.5733 9.47726C20.5137 8.49299 20.3507 7.50088 20.6391 6.51896C20.8397 5.83483 21.132 5.19301 21.6445 4.70088C22.7667 3.62335 23.8936 2.5419 25.2117 1.70026C26.3935 0.946379 27.6967 0.527122 29.0979 0.413492C29.5258 0.379011 29.9521 0.333559 30.3784 0.397035C31.4496 0.556901 32.0915 1.22301 32.2294 2.29897C32.47 4.17504 32.2074 5.97353 31.3086 7.64351C30.6252 8.9146 29.8094 10.112 28.8933 11.224C28.0517 12.2467 26.8778 12.6691 25.5691 12.7381C25.0072 12.7678 24.4445 12.8039 23.8842 12.8587C23.1327 12.9316 22.5551 13.325 22.092 13.8994C19.2128 17.469 16.3353 21.0409 13.4561 24.6112C11.7579 26.7177 10.0503 28.8171 8.3639 30.933C7.92505 31.4839 7.38668 31.8295 6.70647 31.9721C6.45491 31.9721 6.20414 31.9721 5.95337 31.9721ZM31.2717 3.59514C31.2812 3.21741 31.2451 2.84439 31.2044 2.46981C31.1307 1.79116 30.7389 1.40638 30.0508 1.40325C28.4576 1.39541 26.9695 1.77941 25.6255 2.65475C24.6052 3.31929 23.7612 4.19934 22.831 4.97437C21.7433 5.88028 21.4071 7.04871 21.5403 8.42246C21.6093 9.1348 21.6923 9.85498 21.5615 10.5759C21.3883 11.5297 20.8178 12.2326 20.1658 12.9003C17.0413 16.0992 13.9255 19.3059 10.8058 22.5095C8.91795 24.4482 7.02698 26.3839 5.14072 28.3234C4.52477 28.9566 4.58354 29.9573 5.26141 30.5506C5.93457 31.1391 6.91414 31.0764 7.46426 30.3954C9.40852 27.9904 11.3481 25.5822 13.2892 23.1756C15.9779 19.8419 18.6659 16.5067 21.3577 13.1746C21.9901 12.3917 22.8067 11.9231 23.8153 11.8235C24.3756 11.7687 24.9382 11.7295 25.5009 11.706C26.725 11.6543 27.7288 11.1848 28.4341 10.163C29.0101 9.32915 29.5814 8.49221 30.126 7.63802C30.9105 6.40768 31.2647 5.04804 31.2717 3.59514Z"
											fill="#C33B4C"
										/>
										<path
											d="M0.186523 5.07566C0.648097 4.10079 1.5062 3.94954 2.26948 4.71204C3.74119 6.18061 5.20976 7.65153 6.68147 9.12089C6.81469 9.25333 6.95653 9.37715 7.08975 9.50958C7.26529 9.68356 7.41889 9.63183 7.57797 9.48059C7.77075 9.298 7.58973 9.20553 7.48942 9.10443C5.79202 7.40312 4.09227 5.70493 2.39487 4.0044C2.29221 3.90174 2.18877 3.79281 2.11667 3.66899C1.9905 3.45114 2.04222 3.23877 2.22011 3.07185C2.38781 2.91512 2.59392 2.87358 2.79532 3.00288C2.9254 3.08674 3.04295 3.19488 3.15266 3.30459C4.83831 4.9871 6.5216 6.67275 8.2096 8.35369C8.29423 8.43832 8.36163 8.61543 8.53638 8.51042C8.75816 8.3772 8.72211 8.24868 8.54814 8.07549C6.8429 6.38201 5.14629 4.68069 3.4481 2.98094C3.3525 2.88534 3.25297 2.78816 3.18244 2.67453C3.04687 2.45589 3.05549 2.22942 3.24513 2.04447C3.43164 1.86188 3.6542 1.84072 3.87363 1.98648C3.98569 2.06093 4.08365 2.1581 4.17925 2.25293C5.87195 3.94327 7.5623 5.63675 9.25735 7.32475C9.3506 7.41722 9.43132 7.63194 9.62645 7.43368C9.78161 7.27695 9.81766 7.11238 9.67582 6.93292C9.60451 6.84358 9.51987 6.76444 9.43916 6.68293C7.90319 5.14618 6.36801 3.60787 4.82969 2.07347C4.53425 1.77881 4.33442 1.44419 4.4026 1.01396C4.546 0.0947357 5.55457 -0.311982 6.28729 0.271842C7.13677 0.948921 7.95804 1.66048 8.7895 2.36029C10.0606 3.42998 11.3317 4.4981 12.5973 5.57328C13.5353 6.37026 13.9781 7.4133 14.0557 8.62092C14.1043 9.37088 14.0275 10.1232 14.1019 10.8747C14.1709 11.5659 14.4694 12.1286 14.9624 12.5988C15.2194 12.844 15.4906 13.0737 15.746 13.3205C16.0125 13.5791 16.0399 13.8738 15.8361 14.0979C15.6426 14.311 15.3119 14.3134 15.0509 14.0759C14.3723 13.46 13.6403 12.8903 13.3026 11.9828C13.1216 11.4954 13.0455 10.9962 13.0291 10.4813C13.0048 9.72039 13.0973 8.95397 12.9601 8.19853C12.8293 7.47913 12.5111 6.84672 11.9484 6.37026C9.92345 4.6564 7.8883 2.9543 5.85706 1.24749C5.80926 1.20753 5.76224 1.16521 5.71209 1.12759C5.64547 1.07744 5.56946 1.0124 5.49031 1.08763C5.3947 1.17853 5.47229 1.26003 5.53341 1.33056C5.59532 1.40109 5.66428 1.46535 5.73089 1.53196C7.2457 3.04599 8.76051 4.56001 10.2745 6.07482C11.0073 6.80832 11.0057 7.51126 10.2698 8.25181C9.64369 8.88109 9.01598 9.50958 8.38592 10.1357C7.67201 10.8449 6.96437 10.8481 6.25829 10.1428C4.75838 8.64364 3.25924 7.14294 1.76011 5.64381C1.70838 5.59208 1.66215 5.53253 1.60416 5.49021C1.49758 5.41263 1.41138 5.19085 1.25621 5.33505C1.12221 5.45965 1.30323 5.57563 1.38317 5.67045C2.56335 7.08025 3.74667 8.48691 4.93 9.89358C5.40097 10.4531 5.88998 10.9985 6.33979 11.5737C7.06938 12.5063 8.0513 12.8581 9.18995 12.8911C9.93051 12.9122 10.6734 12.8307 11.4108 12.9475C12.1804 13.069 12.834 13.4208 13.3802 13.9678C13.6756 14.2632 13.9538 14.5751 14.2296 14.8886C14.4906 15.1856 14.5008 15.4826 14.2759 15.695C14.0518 15.9066 13.7328 15.8603 13.4546 15.5665C13.2031 15.3008 12.9648 15.0234 12.7109 14.7609C12.1592 14.188 11.4806 13.9278 10.6867 13.9231C9.95637 13.9192 9.22443 13.9702 8.49563 13.8745C7.38833 13.7296 6.43775 13.286 5.70738 12.4169C3.9998 10.3865 2.28907 8.35839 0.583054 6.32637C0.43651 6.15083 0.318178 5.95257 0.186523 5.76527C0.186523 5.53488 0.186523 5.30527 0.186523 5.07566Z"
											fill="#C33B4C"
										/>
										<path
											d="M29.1505 31.9719C28.4421 31.8622 27.921 31.4625 27.4492 30.9421C24.4964 27.6845 21.5318 24.4362 18.5704 21.1864C18.4011 21.0007 18.2718 20.8032 18.3557 20.5391C18.4748 20.1653 18.9411 20.0814 19.2443 20.3988C19.7561 20.9356 20.249 21.4897 20.7482 22.0382C22.5553 24.0232 24.3608 26.0098 26.1679 27.994C26.9061 28.8051 27.6443 29.6162 28.3888 30.421C28.9327 31.0088 29.5925 31.1114 30.2861 30.7321C30.8973 30.3983 31.2304 29.6201 31.0548 28.9297C30.9851 28.6562 30.8174 28.4454 30.6136 28.2589C28.7611 26.5701 26.9101 24.8806 25.0575 23.1918C23.5137 21.7843 21.9699 20.3777 20.4253 18.971C20.2929 18.8503 20.1628 18.7257 20.1322 18.5384C20.0985 18.3315 20.1839 18.1646 20.3509 18.0526C20.5562 17.9154 20.7772 17.9311 20.9629 18.0847C21.2528 18.3237 21.5295 18.5792 21.8069 18.8323C24.5317 21.3157 27.2549 23.8007 29.9796 26.2849C30.4193 26.6861 30.8605 27.0858 31.3017 27.4862C32.1104 28.2197 32.3095 29.1248 31.9905 30.1381C31.6739 31.1428 30.9623 31.7313 29.9287 31.9303C29.8778 31.9405 29.8284 31.957 29.7782 31.9703C29.5682 31.9719 29.3598 31.9719 29.1505 31.9719Z"
											fill="#C33B4C"
										/>
									</svg>
								</div>

								<Components.Paragraph className="font-bold mt-2 text-white">
									Food and Drink
								</Components.Paragraph>
							</div>
						</Slide>

						<Slide index={3} className="h-full flex">
							<div
								className="bg-[#F5F5F5] 
									max-md:min-w-[250px] h-[130px]
									flex flex-col 
									items-center justify-center
									cursor-pointer shadow-sm
									hover:opacity-80
									mx-auto
									aspect-video
									"
							>
								<div
									className="h-[50px] 
                            aspect-square
                            bg-[#C33B4C1A]
                            flex items-center justify-center
                            "
								>
									<svg
										width="36"
										height="33"
										viewBox="0 0 36 33"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M35.1489 7.06069C35.1489 8.98084 35.1828 10.9019 35.1413 12.8211C35.0659 16.3079 33.9602 19.413 31.5169 21.9552C29.5063 24.0479 27.0422 25.0716 24.1125 24.8623C23.9014 24.8472 23.6846 24.8322 23.4847 24.7718C23.1944 24.6842 23.0851 24.8029 23.0059 25.0641C22.6119 26.3602 22.018 27.5592 21.1856 28.6329C19.6567 30.6058 17.6696 31.8218 15.183 32.1244C12.7962 32.4147 10.6291 31.7473 8.67219 30.3994C5.83769 28.4472 4.12869 25.7079 3.24168 22.4256C2.24908 18.755 1.27346 15.0806 0.29029 11.4072C0.265781 11.3157 0.241273 11.2252 0.219592 11.1338C0.0819679 10.5466 0.396808 10.2261 0.975585 10.3891C2.10769 10.7087 3.2709 10.8161 4.43505 10.8086C6.00171 10.7973 7.55611 10.6069 9.08978 10.2666C10.8421 9.87822 12.5408 9.32867 14.1951 8.63206C14.5391 8.4869 14.6343 8.29554 14.6315 7.94206C14.6174 5.68068 14.624 3.41836 14.624 1.15603C14.624 1.07403 14.6287 0.991074 14.623 0.909064C14.5646 0.00979189 15.0764 -0.181563 15.7542 0.217171C17.319 1.13718 19.0572 1.56891 20.835 1.8517C22.4799 2.11281 24.138 2.20047 25.7989 2.12883C28.2563 2.02231 30.6733 1.67825 32.9761 0.751645C33.3814 0.588569 33.7717 0.395329 34.1497 0.177581C34.7822 -0.187219 35.147 0.0154477 35.1479 0.73562C35.1489 2.84429 35.1479 4.95296 35.1479 7.06164C35.1498 7.06069 35.1489 7.06069 35.1489 7.06069ZM22.5317 21.0918C22.543 20.1558 22.4648 19.2282 22.2433 18.3223C21.3223 14.5603 20.2543 10.8378 19.2749 7.09086C19.2155 6.86462 19.1364 6.89667 18.9931 7.01733C18.4596 7.46414 17.8911 7.86476 17.2954 8.2239C14.5175 9.89896 11.502 10.9293 8.32436 11.5071C6.26282 11.8823 4.18808 12.0133 2.1058 11.7079C1.54211 11.6249 1.41862 11.5043 1.62412 12.2631C2.5347 15.6264 3.41323 18.9982 4.33607 22.3578C5.06661 25.0179 6.44286 27.2849 8.60997 29.0297C10.1559 30.274 11.9073 31.0545 13.9085 31.1101C16.5121 31.1827 18.6255 30.1251 20.2383 28.1059C21.8691 26.0614 22.5035 23.6708 22.5317 21.0918ZM34.111 7.18983C34.111 5.39977 34.111 3.60877 34.111 1.81871C34.111 1.42186 34.111 1.42374 33.7368 1.58965C32.9167 1.95162 32.0702 2.24383 31.2002 2.45781C28.2827 3.17516 25.3285 3.38254 22.3357 3.10729C20.128 2.90462 17.9816 2.47289 15.9597 1.53215C15.7316 1.42563 15.7042 1.50764 15.7042 1.7103C15.708 3.66533 15.708 5.62129 15.7042 7.57631C15.7033 7.81857 15.7702 7.8723 15.9899 7.74976C17.0522 7.15496 18.0627 6.48851 18.9346 5.63072C19.4635 5.11038 19.8763 5.21784 20.0686 5.93142C20.2675 6.67044 20.474 7.40758 20.654 8.15038C20.7313 8.47087 20.8859 8.53497 21.1875 8.45862C21.6259 8.34739 21.9388 8.09193 22.1877 7.72714C22.3988 7.41889 22.7184 7.34725 22.9757 7.5273C23.2236 7.70074 23.266 7.99579 23.0719 8.31251C22.6741 8.95821 22.0972 9.36449 21.3553 9.50777C21.0914 9.55867 21.0631 9.65576 21.1272 9.88765C21.542 11.4091 21.9511 12.9324 22.3479 14.4594C22.4177 14.7262 22.5044 14.7281 22.725 14.6102C23.6488 14.1163 24.6404 13.9466 25.6679 14.1361C27.786 14.5264 29.0849 15.961 30.0992 17.7209C30.3292 18.1206 29.9814 18.5589 29.5185 18.4826C28.7984 18.3638 28.0772 18.262 27.3514 18.1894C26.1307 18.0669 24.9062 18.0688 23.6817 18.0942C23.4414 18.0989 23.3056 18.1847 23.3603 18.4647C23.6714 20.0747 23.7053 21.6904 23.4197 23.3079C23.3744 23.5643 23.4423 23.6888 23.7251 23.7349C24.7535 23.9056 25.7706 23.8556 26.7689 23.586C29.4412 22.863 31.2558 21.0984 32.5557 18.7362C33.734 16.5945 34.1242 14.27 34.1129 11.8559C34.1054 10.2996 34.111 8.74424 34.111 7.18983ZM24.8157 15.1212C24.4029 15.1485 23.9202 15.2399 23.4612 15.436C22.7099 15.7574 22.708 15.7603 22.9154 16.553C22.9333 16.6209 22.9606 16.6878 22.9701 16.7576C23.0002 16.9904 23.1331 17.079 23.3603 17.0564C23.4772 17.0451 23.596 17.0545 23.7129 17.0451C25.124 16.9244 26.5285 17.0375 27.9311 17.178C28.0801 17.1931 28.2912 17.277 28.3647 17.1591C28.4562 17.0121 28.2479 16.9056 28.1517 16.8009C27.9538 16.5851 27.7473 16.373 27.5249 16.1816C26.7717 15.5293 25.9045 15.1494 24.8157 15.1212Z"
											fill="#C33B4C"
										/>
										<path
											d="M13.8168 26.7593C12.3708 26.7272 11.1435 26.173 10.0369 25.3199C9.72956 25.0833 9.44677 24.8146 9.1555 24.5573C8.95001 24.3763 8.80673 24.1623 8.90759 23.8739C9.00939 23.5845 9.2639 23.5176 9.53161 23.4959C11.0493 23.3743 12.5377 23.0887 14.0063 22.6975C15.4202 22.3213 16.7899 21.8208 18.1181 21.209C18.3735 21.0912 18.6261 20.9932 18.8769 21.2024C19.1427 21.4249 19.0767 21.7011 18.9919 21.9811C18.529 23.511 17.823 24.8853 16.4996 25.8619C15.6964 26.4557 14.7821 26.7197 13.8168 26.7593ZM17.6062 22.6041C16.4581 23.0641 15.3467 23.4403 14.2127 23.7485C13.0769 24.0577 11.9184 24.2641 10.709 24.4649C13.5274 26.698 16.4562 25.6564 17.6062 22.6041Z"
											fill="#C33B4C"
										/>
										<path
											d="M16.5788 13.875C17.1133 13.8948 17.7053 14.1173 18.1964 14.582C18.4999 14.8685 18.532 15.1711 18.3019 15.4153C18.0804 15.65 17.7995 15.6387 17.4875 15.3813C16.5515 14.6084 15.425 14.9044 14.9924 16.0365C14.8415 16.4324 14.5842 16.5926 14.2807 16.4814C13.9687 16.3673 13.8574 16.0789 13.9762 15.6933C14.308 14.6187 15.3176 13.8741 16.5788 13.875Z"
											fill="#C33B4C"
										/>
										<path
											d="M8.49444 15.973C9.30699 15.9626 9.91688 16.2039 10.4287 16.6847C10.7125 16.9505 10.7389 17.254 10.5183 17.4944C10.3128 17.7178 10.0017 17.7385 9.73495 17.485C8.79891 16.5998 7.46037 17.1286 7.18701 18.1552C7.08709 18.5322 6.79582 18.668 6.48569 18.5652C6.19065 18.4672 6.07565 18.1797 6.18311 17.8073C6.49323 16.7393 7.46037 16.0041 8.49444 15.973Z"
											fill="#C33B4C"
										/>
										<path
											d="M28.9399 9.558C28.0067 9.5316 27.2639 9.14984 26.7577 8.34954C26.5362 7.99982 26.5814 7.67839 26.8529 7.5106C27.1282 7.33998 27.4175 7.43519 27.657 7.77454C28.3319 8.73037 29.5093 8.74073 30.1974 7.79622C30.2247 7.75851 30.2483 7.71703 30.2775 7.68027C30.4792 7.42388 30.7828 7.35318 31.0203 7.52285C31.2833 7.71044 31.3267 7.97155 31.1711 8.23831C30.6762 9.08857 29.9268 9.52501 28.9399 9.558Z"
											fill="#C33B4C"
										/>
									</svg>
								</div>

								<Components.Paragraph className="font-bold mt-2">
									Stanwix Theatre
								</Components.Paragraph>
							</div>
						</Slide>

						<Slide index={4} className="h-full flex">
							<div
								className="bg-[#F5F5F5] 
									max-md:min-w-[250px] h-[130px]
									flex flex-col 
									items-center justify-center
									cursor-pointer shadow-sm
									hover:opacity-80
									mx-auto
									aspect-video
									"
							>
								<div
									className="h-[50px] 
                            aspect-square
                            bg-[#C33B4C1A]
                            flex items-center justify-center
                            "
								>
									<svg
										width="34"
										height="34"
										viewBox="0 0 34 34"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M26.52 12.7589C26.4995 11.9724 26.5467 11.0933 26.4835 10.2142C26.4737 10.0824 26.4835 9.94609 26.5022 9.81516C26.552 9.45621 26.715 9.30479 27.0758 9.2941C27.4098 9.2843 27.7438 9.28252 28.0778 9.2941C28.2782 9.30122 28.3985 9.23353 28.5071 9.05717C28.9097 8.4034 29.6169 8.14153 30.2859 8.37489C30.953 8.60737 31.369 9.26025 31.2995 9.96747C31.2327 10.6471 30.6867 11.21 29.959 11.2919C29.3702 11.3587 28.8973 11.1138 28.5534 10.6293C28.3593 10.3558 27.9308 10.2195 27.6307 10.3318C27.5087 10.3772 27.5006 10.4716 27.5015 10.574C27.5069 12.0321 27.5131 13.4902 27.5211 14.9483C27.5229 15.2039 27.5434 15.4604 27.5389 15.7152C27.5354 15.9352 27.6084 16.0483 27.848 16.0349C28.0814 16.0216 28.3165 16.0216 28.549 16.0358C28.7832 16.0501 28.8634 15.9557 28.8572 15.725C28.8367 14.9126 28.8242 14.1003 28.818 13.288C28.8126 12.514 28.9543 12.3652 29.7327 12.3759C30.0855 12.3804 30.3384 12.3323 30.5495 11.9787C30.8826 11.4193 31.6121 11.2225 32.2312 11.4282C32.8511 11.634 33.2439 12.1853 33.2448 12.8489C33.2457 13.5125 32.8538 14.0647 32.2356 14.2722C31.613 14.4815 30.9325 14.2678 30.5388 13.736C30.4863 13.6648 30.4444 13.5846 30.3945 13.5116C30.2841 13.3521 30.1184 13.3869 29.9688 13.4127C29.8182 13.4376 29.8387 13.573 29.8387 13.6817C29.8369 14.372 29.8441 15.0623 29.8352 15.7526C29.8325 15.9788 29.9305 16.0376 30.1371 16.0358C30.961 16.0287 31.7849 16.0314 32.6088 16.034C33.0898 16.0358 33.2421 16.1917 33.2448 16.678C33.2474 17.1456 33.2474 17.6133 33.2448 18.0809C33.2385 19.0117 32.6088 19.6565 31.6825 19.6832C30.2155 19.726 29.0843 20.6301 28.7441 22.0463C28.4938 23.0893 28.7637 24.0049 29.4691 24.7985C30.2048 25.626 30.1906 26.4303 29.4156 27.2088C28.7316 27.8946 28.0484 28.5805 27.3608 29.2627C26.642 29.9762 25.7923 29.994 25.0476 29.318C24.059 28.4201 22.9313 28.1992 21.7102 28.7265C20.5095 29.2449 19.9261 30.2158 19.8807 31.5153C19.8495 32.3998 19.2011 33.0411 18.3139 33.0456C17.2451 33.0509 16.1763 33.0518 15.1074 33.0456C14.2434 33.0402 13.5932 32.3936 13.562 31.5287C13.4997 29.7749 12.2981 28.5235 10.5515 28.4522C9.75607 28.4201 9.05153 28.7221 8.45387 29.261C7.61394 30.0181 6.81765 29.9976 6.02136 29.204C5.34354 28.5279 4.66571 27.851 3.99056 27.1723C3.26286 26.4401 3.24594 25.5993 3.9389 24.836C5.50476 23.1116 4.7726 20.4261 2.56366 19.8008C2.29556 19.7251 2.02122 19.6886 1.74065 19.6815C0.839259 19.6574 0.203298 19.0036 0.197063 18.096C0.1935 17.6061 0.192609 17.1162 0.197954 16.6264C0.202407 16.2051 0.366296 16.0376 0.784926 16.0349C1.57498 16.0296 2.36592 16.0331 3.15597 16.0331C3.60311 16.0331 3.60311 16.0323 3.604 15.6012C3.60489 15.0115 3.61112 14.421 3.60043 13.8313C3.59776 13.6835 3.69663 13.4715 3.45525 13.41C3.2397 13.3548 3.08739 13.4314 2.9618 13.6381C2.68301 14.0968 2.26082 14.339 1.71393 14.3426C0.977318 14.3488 0.360061 13.8625 0.21844 13.1633C0.0741461 12.4525 0.445569 11.7417 1.10291 11.4683C1.7647 11.1931 2.55831 11.406 2.92617 12.0188C3.09808 12.3056 3.2878 12.4071 3.59509 12.3715C3.69396 12.3599 3.7955 12.3697 3.89526 12.3724C4.42968 12.3857 4.62118 12.5639 4.62296 13.1054C4.62474 13.9284 4.5998 14.7523 4.5909 15.5753C4.58555 16.0314 4.59 16.0314 5.04693 16.0323C5.89666 16.034 5.87707 16.0331 5.90913 15.1959C5.96436 13.7271 5.93229 12.2575 5.93853 10.7887C5.93942 10.6319 6.04274 10.4146 5.79334 10.3309C5.50565 10.2338 5.08523 10.338 4.95252 10.5331C4.52587 11.1601 3.95404 11.4131 3.30116 11.2634C2.66609 11.1174 2.17887 10.5527 2.14057 9.91581C2.09871 9.22462 2.49864 8.61271 3.14261 8.38024C3.76878 8.15489 4.49025 8.36332 4.8492 8.93604C5.03001 9.22373 5.22953 9.32438 5.55018 9.29677C5.81561 9.27361 6.0846 9.28608 6.35092 9.29499C6.73036 9.30657 6.88802 9.4571 6.94591 9.83386C6.98866 10.1135 6.92721 10.3888 6.92721 10.6667C6.92721 12.3252 6.93077 13.9845 6.91563 15.643C6.91295 15.9503 7.00203 16.0545 7.31199 16.0394C7.80098 16.0162 8.29176 16.0296 8.78076 16.0349C9.21453 16.0394 9.37218 16.2051 9.39089 16.646C9.51024 19.4249 10.7652 21.5377 13.1675 22.9281C17.4428 25.4016 23.1032 22.7188 23.9218 17.8537C23.9904 17.4476 24.0438 17.0405 24.0509 16.6281C24.0581 16.2095 24.2291 16.0403 24.6433 16.0358C25.1661 16.0296 25.6898 16.0251 26.2127 16.0376C26.4469 16.0429 26.5235 15.9557 26.5209 15.7259C26.5146 14.7666 26.52 13.8091 26.52 12.7589ZM4.81802 17.0147C3.79372 17.0147 2.7703 17.0138 1.74599 17.0156C1.11538 17.0165 1.18218 16.9577 1.1804 17.5963C1.17773 18.5538 1.25076 18.6304 2.20292 18.707C4.09656 18.8585 5.72476 20.5971 5.79156 22.4952C5.83342 23.6736 5.45755 24.6765 4.66839 25.5396C4.37802 25.8576 4.36377 26.1043 4.64256 26.3876C5.37471 27.1349 6.11489 27.8741 6.86219 28.6072C7.12761 28.8682 7.36543 28.8584 7.66293 28.6179C7.74932 28.5484 7.83038 28.4709 7.91678 28.4014C9.24125 27.3362 10.6993 27.1447 12.2313 27.843C13.725 28.5244 14.4554 29.7589 14.5801 31.3791C14.6211 31.9126 14.8055 32.0622 15.3541 32.064C16.1665 32.0667 16.9788 32.0649 17.792 32.0649C18.7504 32.0649 18.8279 31.9936 18.9045 31.0433C19.0568 29.1487 20.7928 27.5196 22.69 27.4528C23.8684 27.411 24.8713 27.7842 25.7353 28.5742C26.0532 28.8646 26.3018 28.8806 26.5841 28.6036C27.3314 27.8715 28.0707 27.1313 28.8037 26.384C29.0665 26.1168 29.0576 25.879 28.818 25.5833C28.7476 25.4969 28.6728 25.4149 28.6015 25.3294C27.3804 23.8713 27.3225 21.8183 28.459 20.2952C29.2535 19.2308 30.3402 18.74 31.6424 18.658C32.0726 18.6313 32.2463 18.4291 32.2623 17.9918C32.2686 17.803 32.2472 17.6115 32.2677 17.4244C32.3024 17.1064 32.1884 17.0049 31.8615 17.0067C29.7693 17.02 27.6761 17.0138 25.5838 17.0138C25.0753 17.0138 25.0753 17.0138 25.0093 17.5046C24.3493 22.4168 19.8736 25.6394 15.0317 24.689C11.5615 24.0076 8.76561 20.9463 8.43962 17.4333C8.40577 17.0655 8.28107 17.0022 7.95775 17.0076C6.91117 17.0254 5.8646 17.0147 4.81802 17.0147ZM3.661 10.2881C3.92287 10.2819 4.1402 10.053 4.13486 9.78755C4.1304 9.52835 3.90416 9.32082 3.62894 9.32438C3.34302 9.32795 3.16043 9.52212 3.16755 9.81605C3.17557 10.0886 3.38934 10.2944 3.661 10.2881ZM29.8129 9.32349C29.5377 9.32082 29.3123 9.52924 29.3088 9.78844C29.3052 10.0548 29.5216 10.2819 29.7835 10.2881C30.0543 10.2944 30.2689 10.0877 30.2752 9.81427C30.2814 9.52123 30.0979 9.32616 29.8129 9.32349ZM2.18511 12.8738C2.19936 12.6235 1.96956 12.3724 1.71393 12.359C1.46186 12.3456 1.21157 12.5737 1.19732 12.8284C1.18396 13.0751 1.41822 13.3316 1.6685 13.3468C1.91345 13.361 2.17086 13.125 2.18511 12.8738ZM32.2463 12.8471C32.2436 12.5924 32.0031 12.3563 31.7475 12.359C31.491 12.3617 31.2549 12.6013 31.2576 12.856C31.2612 13.1081 31.507 13.3504 31.7564 13.3477C32.0067 13.3441 32.249 13.0974 32.2463 12.8471Z"
											fill="#C33B4C"
										/>
										<path
											d="M21.5095 7.16632C20.4077 6.28274 20.1182 5.58087 20.4594 4.65098C20.7533 3.84935 21.5184 3.36569 22.4296 3.40578C23.2179 3.44051 23.9233 4.01502 24.1522 4.80863C24.4105 5.70824 24.0498 6.47781 23.0353 7.16008C23.4494 7.29458 23.8494 7.42462 24.2065 7.6571C25.1703 8.28504 25.7261 9.17396 25.8802 10.3069C25.9924 11.1291 25.6833 11.6626 24.9191 12.0242C24.3686 12.2843 23.7808 12.4028 23.1813 12.466C22.7164 12.515 22.2506 12.5533 21.782 12.5114C21.6903 12.5034 21.6066 12.5123 21.5318 12.5756C20.6473 13.3139 19.5749 13.5696 18.4767 13.7139C16.8876 13.9223 15.3031 13.884 13.7426 13.4698C13.1031 13.3006 12.4902 13.0672 11.9772 12.6334C11.8436 12.5203 11.6966 12.5168 11.539 12.5212C10.7454 12.5444 9.96066 12.4731 9.19198 12.2665C7.69293 11.863 7.24223 11.0418 7.74014 9.56765C8.11156 8.46763 8.86687 7.72123 9.95353 7.3115C10.0969 7.25717 10.2457 7.21531 10.4033 7.16365C9.35409 6.39943 9.02275 5.66103 9.31133 4.75074C9.56786 3.94376 10.2973 3.40578 11.1426 3.40043C12.0057 3.39509 12.7396 3.90991 13.0051 4.7062C13.3177 5.645 13.0069 6.36469 11.9407 7.15296C12.2061 7.25272 12.4609 7.35337 12.72 7.44422C12.8973 7.50657 12.9819 7.34891 13.0826 7.25984C13.8682 6.56331 14.7696 6.10638 15.809 5.93804C17.4256 5.67618 18.8882 6.04849 20.1476 7.09239C20.4843 7.37118 20.756 7.53329 21.1594 7.28211C21.2565 7.22243 21.3839 7.2064 21.5095 7.16632ZM16.7193 12.8303C17.1451 12.8588 17.5655 12.792 17.985 12.7546C18.7617 12.6869 19.5286 12.5444 20.2456 12.2157C21.0472 11.8478 21.2307 11.5023 21.1016 10.6356C20.788 8.54156 18.9692 6.91603 16.877 6.86081C14.6965 6.80291 12.8109 8.30464 12.3896 10.4343C12.1758 11.5147 12.386 11.9022 13.4112 12.3048C14.4747 12.7225 15.5961 12.7858 16.7193 12.8303ZM11.1604 8.12471C9.81013 8.12115 8.65311 9.18109 8.57651 10.4646C8.55691 10.795 8.68606 10.9874 8.97376 11.1157C9.60616 11.398 10.2751 11.4711 10.9565 11.5005C11.2246 11.5121 11.2985 11.4061 11.2994 11.1513C11.3021 10.3488 11.5123 9.5917 11.8596 8.87201C12.1634 8.24318 12.1135 8.15856 11.3947 8.12471C11.3163 8.12204 11.2379 8.12471 11.1604 8.12471ZM22.2452 8.12026C22.0234 8.1069 21.7625 8.15143 21.5041 8.22804C21.3349 8.27881 21.2948 8.35362 21.391 8.51662C21.8872 9.35745 22.1463 10.2669 22.1535 11.2448C22.1544 11.4052 22.2087 11.4969 22.3842 11.496C23.1234 11.4907 23.8485 11.4105 24.5272 11.0881C24.7739 10.9714 24.8835 10.7897 24.8719 10.5038C24.8185 9.20781 23.6543 8.12293 22.2452 8.12026ZM10.2519 5.34394C10.2564 5.86233 10.6866 6.28987 11.1889 6.27473C11.6824 6.25958 12.0939 5.83561 12.0957 5.33771C12.0983 4.82377 11.6726 4.39178 11.1676 4.39446C10.6536 4.39713 10.2475 4.81843 10.2519 5.34394ZM23.1965 5.33058C23.1956 4.80952 22.7761 4.38733 22.2666 4.39356C21.7562 4.40069 21.3438 4.83179 21.3518 5.35018C21.3599 5.84808 21.7785 6.27027 22.2702 6.27473C22.777 6.27918 23.1974 5.84986 23.1965 5.33058Z"
											fill="#C33B4C"
										/>
										<path
											d="M16.743 16.0314C18.5458 16.0314 20.3495 16.0305 22.1522 16.0314C22.7196 16.0314 22.8942 16.2496 22.8523 16.8161C22.6965 18.9244 21.7505 20.5695 19.9736 21.715C16.3814 24.029 11.4558 21.8762 10.696 17.6676C10.6426 17.3728 10.6132 17.0735 10.5856 16.7742C10.5366 16.2559 10.7441 16.0323 11.267 16.0314C13.092 16.0305 14.9171 16.0314 16.743 16.0314ZM16.6976 17.0138C15.1522 17.0138 13.6059 17.0138 12.0606 17.0138C11.6108 17.0138 11.6019 17.0236 11.6776 17.4547C12.0962 19.8552 14.2677 21.6517 16.7457 21.6473C19.196 21.6428 21.3533 19.8338 21.7648 17.4396C21.8289 17.0655 21.7879 17.0147 21.4023 17.0147C19.8337 17.013 18.2661 17.0138 16.6976 17.0138Z"
											fill="#C33B4C"
										/>
										<path
											d="M19.4866 2.78705C19.4821 4.3146 18.2556 5.54288 16.7272 5.55C15.1854 5.55713 13.9482 4.29857 13.9571 2.73004C13.966 1.182 15.1907 -0.00797605 16.7664 4.02621e-05C18.293 0.00805658 19.491 1.23633 19.4866 2.78705ZM16.7085 4.54262C17.6749 4.55064 18.5014 3.73119 18.5014 2.76389C18.5014 1.8144 17.6945 1.00208 16.7361 0.986938C15.7786 0.971796 14.9395 1.80638 14.9431 2.76923C14.9475 3.72496 15.7536 4.53549 16.7085 4.54262Z"
											fill="#C33B4C"
										/>
									</svg>
								</div>

								<Components.Paragraph className="font-bold mt-2">
									IT Facilities
								</Components.Paragraph>
							</div>
						</Slide>
					</Components.Carousel>
				</div>

				{/* button */}
				<Components.Button
					text="View All Facilities"
					className={"w-fit mx-auto"}
				/>
			</div>

			{/* Fantastic */}
			<div
				className="FANTASTIC relative 
				min-h-[500px] w-full 
				flex flex-col items-center justify-center 
				p-12 md:px-24 
				z-0 overflow-hidden
				"
				style={{
					backgroundImage: `url(${fantasticBg})`,
					backgroundSize: "cover",
					backgroundPosition: "center",
					backgroundRepeat: "no-repeat",
				}}
			>
				<div className="absolute top-0 left-0 w-full h-full z-10 bg-[#C33B4CCC]" />

				<div className="z-20 text-white flex flex-col items-center">
					<Components.SubHeading
						style={{ lineHeight: 1.2 }}
						className="max-w-[600px]"
					>
						FANTASTIC FACILITIES TO ENHANCE YOUR UNIVERSITY EXPERIENCE{" "}
					</Components.SubHeading>
				</div>
			</div>

			{/* Teaching */}
			<div
				className="TEACHING bg-white 
				w-full 
				flex flex-col"
			>
				{/* inner container */}
				<div
					className="h-fit
				 	w-full max-w-[1400px] 
					flex flex-col md:flex-row 
					items-center justify-center 
					m-auto 
					px-12 py-24 lg:px-24"
				>
					{/* left */}
					<img
						loading="lazy"
						src={teachingBg}
						alt="move_img"
						className="max-md:hidden w-full md:w-[55%] lg:w-[50%] object-contain"
					/>
					<img
						loading="lazy"
						src={teachingBg1}
						alt="move_img"
						className="md:hidden w-full md:w-[55%] lg:w-[50%] object-contain"
					/>

					{/* right */}
					<div
						className="Quote relative z-10 
						md:aspect-square 
						w-[90%] md:w-[55%] lg:w-[50%] 
						mb-10 md:mb-0 md:ml-[-50px]
						max-md:mt-[-50px]
						"
					>
						{/* right items */}
						<div
							className="relative bg-[#FFDED1] z-10 
							h-full w-full 
							flex flex-col justify-between 
							py-[40px] px-[30px] md:p-[25px] lg:p-[40px] 
                            "
						>
							<Components.SubHeading className="text-start">
								TEACHING AND LEARNING
							</Components.SubHeading>

							{/* text */}
							<Components.Paragraph
								className="text-left 
								mb-auto mt-2 xl:mt-5
							"
							>
								Our teaching and learning facilities boast practical workspaces
								which enhance the learning experience. With nearly 250 staff
								employed across all main campuses, we have a diverse variety of
								expertise to support the university community. Our services
								range from accommodation, space management, reception and
								cleaning to sport and fitness facilities, catering, conferences,
								security, travel and printing.
							</Components.Paragraph>
						</div>

						{/* borders */}
						<div
							style={{
								height: "calc( 100% + 50px )",
								width: "30%",
							}}
							className="absolute 
							hidden md:block 
							top-[-25px] right-[-25px] 
							border-[2px] border-[#FFE300] 
							-z-10
							"
						/>
						<div
							style={{
								height: "40%",
								width: "calc( 100% + 40px )",
							}}
							className="absolute 
							md:hidden 
							bottom-[-20px] left-[-20px] 
							border-[2px] border-[#FFE300] 
							-z-10
							"
						/>
					</div>
				</div>
			</div>

			{/* May Also Like */}
			<div
				className="ALSO-LIKE relative bg-[#F5F5F5]
			 	min-h-[100vh] 
			 	w-full 
			 	flex flex-col
				py-24
			 	"
			>
				{/* heading & btns*/}
				<div className="relative flex justify-between px-12 md:px-24">
					<h1 className="text-[25px] md:text-[50px] lg:text-[50px] font-bold font-[riffic]">
						You Might Also Like...
					</h1>

					{/* buttons */}
					<div className="hidden md:flex items-center">
						<Components.ArrowLeft className="h-[28px]" />

						<Components.ArrowRight className="h-[32px] ml-2" />
					</div>
				</div>

				{/* cards */}
				<div className="w-full flex justify-center px-12 md:px-24 my-16 overflow-hidden">
					<Components.Carousel slidesTotal={5}>
						<Slide index={1} className="h-full flex">
							<div
								className="max-md:max-w-[300px] flex flex-col
								shadow-sm mx-auto p-1 cursor-pointer
								bg-[#F5F5F5] 
								"
							>
								<img
									loading="lazy"
									src={support}
									alt="book_img"
									className="w-full"
								/>
								<div className="details text-left py-5 px-4">
									<Components.BigParagraph className="text-left text-[#C33B4C] font-bold font-[riffic] capitalize">
										STUDENT SUPPORT{" "}
									</Components.BigParagraph>
									<p className="text-[14px] opacity-60">
										We have plenty of support services for our students. Click
										here to find out more.
									</p>
									<Components.Button
										text={"Read More"}
										className="bg-transparent !p-0 text-[10px] !text-[#F38315] mt-2"
										arrowHeight={8}
										arrowWidth={14}
										arrowFill={"#F38315"}
									/>
								</div>
							</div>
						</Slide>

						<Slide index={2} className="h-full flex">
							<div
								className="max-md:max-w-[300px] flex flex-col
								shadow-sm mx-auto p-1 cursor-pointer
							bg-[#C33B4C] 
						"
							>
								<img
									loading="lazy"
									src={campuses}
									alt="book_img"
									className="w-full"
								/>
								<div className="details text-left py-5 px-4">
									<Components.BigParagraph className="text-left text-white font-bold font-[riffic] capitalize">
										CAMPUSES
									</Components.BigParagraph>
									<p className="text-[14px] text-white">
										See what we have available at our campuses across the
										country.
									</p>
									<Components.Button
										text={"Read More"}
										className="bg-transparent !p-0 text-[10px] mt-2"
										arrowHeight={8}
										arrowWidth={14}
									/>
								</div>
							</div>
						</Slide>

						<Slide index={3} className="h-full flex">
							<div
								className="max-md:max-w-[300px] flex flex-col
								shadow-sm mx-auto p-1 cursor-pointer
								bg-[#F5F5F5] 
								"
							>
								<img
									loading="lazy"
									src={union}
									alt="book_img"
									className="w-full"
								/>
								<div className="details text-left py-5 px-4">
									<Components.BigParagraph className="text-left text-[#C33B4C] font-bold font-[riffic] capitalize">
										STUDENTS UNION
									</Components.BigParagraph>
									<p className="text-[14px] opacity-60">
										Welcome to the University of KidverCity Student Union. Find
										out what we can do for you.
									</p>
									<Components.Button
										text={"Read More"}
										className="bg-transparent !p-0 text-[10px] !text-[#F38315] mt-2"
										arrowHeight={8}
										arrowWidth={14}
										arrowFill={"#F38315"}
									/>
								</div>
							</div>
						</Slide>

						<Slide index={4} className="h-full flex">
							<div
								className="max-md:max-w-[300px] flex flex-col
								shadow-sm mx-auto p-1 cursor-pointer
							bg-[#C33B4C] 
						"
							>
								<img
									loading="lazy"
									src={campuses}
									alt="book_img"
									className="w-full"
								/>
								<div className="details text-left py-5 px-4">
									<Components.BigParagraph className="text-left text-white font-bold font-[riffic] capitalize">
										CAMPUSES
									</Components.BigParagraph>
									<p className="text-[14px] text-white">
										See what we have available at our campuses across the
										country.
									</p>
									<Components.Button
										text={"Read More"}
										className="bg-transparent !p-0 text-[10px] mt-2"
										arrowHeight={8}
										arrowWidth={14}
									/>
								</div>
							</div>
						</Slide>

						<Slide index={5} className="h-full flex">
							<div
								className="max-md:max-w-[300px] flex flex-col
								shadow-sm mx-auto p-1 cursor-pointer
								bg-[#F5F5F5] 
								"
							>
								<img
									loading="lazy"
									src={union}
									alt="book_img"
									className="w-full"
								/>
								<div className="details text-left py-5 px-4">
									<Components.BigParagraph className="text-left text-[#C33B4C] font-bold font-[riffic] capitalize">
										STUDENTS UNION
									</Components.BigParagraph>
									<p className="text-[14px] opacity-60">
										Welcome to the University of KidverCity Student Union. Find
										out what we can do for you.
									</p>
									<Components.Button
										text={"Read More"}
										className="bg-transparent !p-0 text-[10px] !text-[#F38315] mt-2"
										arrowHeight={8}
										arrowWidth={14}
										arrowFill={"#F38315"}
									/>
								</div>
							</div>
						</Slide>
					</Components.Carousel>
				</div>

				{/* button */}
				<Components.Button text="View All" className={"w-fit mx-auto"} />
			</div>

			{/* Footer */}
			<Components.Footer />
		</div>
	);
}
